<mat-card class="overview-card table-card total-table-border">
	<mat-card-title>
		<mat-list class="trip-card-header">
			<mat-list-item>
				<h5 class="mt-0">Pilots</h5>
			</mat-list-item>
		</mat-list>
	</mat-card-title>
	<div *ngIf="calculatedPilotRates.length" class="pilots-table">
		<ag-grid-angular
			style="width: 100%"
			[style.height]="calculatedPilotRates.length < 35 ? 70 + calculatedPilotRates.length * 30 + 'px' : '350px'"
			class="ag-theme-balham"
			[gridOptions]="gridOptions"
			[rowData]="calculatedPilotRates"
			[columnDefs]="pilotColumnDefs"
		>
		</ag-grid-angular>
	</div>
</mat-card>
